module.exports = __webpack_public_path__ + "static/media/3_3.0494f5fe.png";